import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import CompanyLayout from '../../components/Company/CompanyLayout';
import Card from '../../components/UI/Card';
import Button from '../../components/UI/Button';
import ResumePreview from '../../components/Resume/ResumePreview';
import * as companyResumeService from '../../services/companyResumeService';
import { toast } from 'react-toastify';

export default function CandidateDetails() {
	const { id } = useParams();
	const [candidate, setCandidate] = useState(null);
	const [tab, setTab] = useState('overview');
	const [zoom, setZoom] = useState(0.9);

	useEffect(() => {
		(async () => {
			try {
				const res = await companyResumeService.getCandidateDetails(id);
				setCandidate(res.resume || res);
			} catch {
				toast.error('Failed to load candidate');
			}
		})();
	}, [id]);

	if (!candidate) return null;
	const name = candidate.sections?.personalInfo?.name || 'Candidate';

	return (
		<CompanyLayout>
			<div className="space-y-6">
				<nav className="text-sm text-gray-500">
					<Link to="/company/resumes" className="hover:underline">Candidates</Link> &gt; <span className="text-gray-700">{name}</span>
				</nav>
				<header className="flex items-center justify-between">
					<h1 className="text-2xl font-bold">{name}</h1>
					<div className="flex items-center gap-2">
						<Button variant="ghost" onClick={() => toast.info('Match with job')}>Match with Job</Button>
						<Button variant="ghost" onClick={() => window.print()}>Print</Button>
					</div>
				</header>

				<div className="flex items-center gap-2 border-b">
					{['overview', 'resume', 'analysis', 'activity', 'notes'].map((t) => (
						<button key={t} className={`px-3 py-2 ${tab === t ? 'border-b-2 border-blue-600 text-blue-700' : 'text-gray-600'}`} onClick={() => setTab(t)}>
							{t[0].toUpperCase() + t.slice(1)}
						</button>
					))}
				</div>

				{tab === 'overview' && (
					<Card title="Overview">
						<div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
							<div>
                                <p className="text-gray-500">Email</p>
                                <p className="font-medium">{candidate.sections?.personalInfo?.email || '-'}</p>
                            </div>
							<div>
                                <p className="text-gray-500">Phone</p>
                                <p className="font-medium">{candidate.sections?.personalInfo?.phone || '-'}</p>
                            </div>
							<div>
                                <p className="text-gray-500">Location</p>
                                <p className="font-medium">{candidate.sections?.personalInfo?.location || '-'}</p>
                            </div>
							<div>
                                <p className="text-gray-500">Uploaded</p>
                                <p className="font-medium">{new Date(candidate.createdAt || Date.now()).toLocaleString()}</p>
                            </div>
						</div>
						<div className="mt-3">
							<p className="text-gray-500 text-sm">Summary</p>
							<p className="text-sm">{candidate.sections?.personalInfo?.summary || '-'}</p>
						</div>
						<div className="mt-3">
							<p className="text-gray-500 text-sm">Key Skills</p>
							<div className="flex flex-wrap gap-2">
								{(candidate.sections?.skills || []).flatMap((c) => c.items || []).map((s, i) => (
									<span key={i} className="px-2 py-0.5 bg-gray-100 rounded text-xs">{s}</span>
								))}
							</div>
						</div>
					</Card>
				)}

				{tab === 'resume' && (
					<Card title="Full Resume">
						<div className="flex items-center gap-2 mb-2">
							<button className="p-1 rounded hover:bg-gray-100" onClick={() => setZoom((z) => Math.max(0.5, z - 0.1))}>-</button>
							<button className="p-1 rounded hover:bg-gray-100" onClick={() => setZoom((z) => Math.min(1.5, z + 0.1))}>+</button>
						</div>
						<ResumePreview resumeData={candidate} templateType={candidate.templateType} zoom={zoom} />
					</Card>
				)}

				{tab === 'analysis' && (
					<Card title="Match Analysis">
						<p className="text-sm text-gray-600">No match data yet.</p>
					</Card>
				)}

				{tab === 'activity' && (
					<Card title="Activity Log">
						<p className="text-sm text-gray-600">Activity timeline coming soon.</p>
					</Card>
				)}

				{tab === 'notes' && (
					<Card title="Notes">
						<p className="text-sm text-gray-600">Notes coming soon.</p>
					</Card>
				)}
			</div>
		</CompanyLayout>
	);
}


